module.exports = __webpack_public_path__ + "static/img/volume.4599e6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/volume.png
// module id = IvEB
// module chunks = 1